import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

const LoadingView = ({}) => {

  const dispatch = useDispatch();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  useEffect(() => {
  }, []);

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      // style={{ position: "fixed", height: "100vh", width: "100vw" }}
      style={{ position: "absolute", height: "100vh", width: "100vw",background:"white",zIndex:9000 }}
    >
      <div
        className="loader"
        style={{ position: "absolute", top: "50%", left: "50%", margin: 0 }}
        // style={{
        //   position: "absolute",
        //   top: 0,
        //   left: 0,
        //   right: 0,
        //   bottom: 0,
        //   margin: "auto",
        // }}
      >
        Loading...
      </div>
      {/* // <div className="loader" style={{position:"fixed", top: "50%", left: "50%",margin:0 }}>Loading...</div> */}
      {/* // <div className="loader" style={{position:"fixed", top: "50%", left: "50%",margin:0 }}>Loading...</div> */}
    </div>
  );
};

export default LoadingView;
